//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import contentBuilder from './rxContentBuilder.vue';
import pListedWeightWarning from '../pListedWeightWarning/index.vue';

export default {
  name: 'RxContentList',
  components: { contentBuilder, pListedWeightWarning },
  computed: {
    ...mapGetters({
      contentChanges: 'rxContent/getContentList',
      checkRxApprovalData: 'rxApproval/getRxApprovalDetail',
      rxEditApproval: 'rxApproval/getRxEditApproval',
      previousMonthButton: 'rxContent/getPreviousMonthButtonStatus',
      rxEmptyBottle: 'rxApproval/getRxEmptyBottle',
    }),
  },
  data: () => ({
    contentList: [],
    addToApprovalListBtn: true,
    previousMonthBtn: true,
  }),
  created() {
    this.$scaleSocketsConnect();
    this.contentList = this.$store.state.rxContent.contentList;
    if (!this.$store.state.rxContent.previousMonthButton) {
      this.previousMonthBtn = this.$store.state.rxContent.previousMonthButton;
    }
  },
  beforeDestroy() {
    this.$scaleSocketsDisconnect();
  },
  methods: {
    addNewContentDetails() {
      if (this.contentList.length < 12) {
        this.$store.dispatch('rxContent/addAnotherContentAction');
        this.$store.commit('rxContent/setContentValue', {
          index: this.contentList.length - 1,
          field: 'residualWeight',
          value: this.contentList[0].residualWeight,
        }, { root: true });
        if (this.rxEmptyBottle) {
          this.$store.commit('rxContent/setContentValue', {
            index: this.contentList.length - 1,
            field: 'billUnits',
            value: this.$store.state.rxContent.billUnitList,
          }, { root: true });
        }
      }
    },
    saveRxItem(type, validate = false) {
      const rxApprovalData = this.$store.state.rxApproval.rxApprovalDetail;
      rxApprovalData.stopId = this.$store.state.stopDetail.stopDetail.id;
      rxApprovalData.contentList = this.contentList;
      rxApprovalData.rxEmptyBottle = this.rxEmptyBottle;
      rxApprovalData.allow_consolidate = validate;
      if (rxApprovalData.id && type === 'create') {
        this.$store.dispatch('rxApprovalList/setRxApprovalDataAction', rxApprovalData);
      } else {
        this.$store.dispatch('rxApprovalList/updateRxApprovalDataAction', rxApprovalData).then(() => {
          this.$router.push({ name: 'Rx Approval List' });
        });
      }
    },
    resetRxItem() {
      this.$store.commit('resetConsolidateApproval');
      this.$router.push({ name: 'stopDetailWorkArea' });
    },
    getPreviousMonthImageUrl() {
      let imageUrl = 'src/assets/images/plus-circle-icon.svg';
      if (this.previousMonthBtn) {
        imageUrl = 'src/assets/images/plus-circle-grey-icon.svg';
      }
      return imageUrl;
    },
    rxItemAddToApproval() {
      if (this.rxEditApproval && !this.rxEditApproval.id && !this.checkRxApprovalData.editType) {
        this.saveRxItem('create', true);
      } else {
        this.saveRxItem('update', true);
      }
    },

  },
  watch: {
    contentChanges(newVal) {
      this.contentList = newVal;
    },
    previousMonthButton(newVal) {
      this.addToApprovalListBtn = newVal;
      this.previousMonthBtn = newVal;
    },
  },
};
